import React from "react";
import ExportWorkedTimeTableView from "./ExportWorkedTimeTableView/ExportWorkedTimeTableView";
import ExportWorkedTimeTotalsView from "./ExportWorkedTimeTotalsView/ExportWorkedTimeTotalsView";
import { LoadResponse } from "../../../../models/api/load";
import { DTOModel } from "../../../../models/base/dto-model";
import { EmployeeGroupDTO } from "../../../../models/employee-groups";
import { TnAWorkedTimeDTO } from "../../../../models/tna-worked-time";
import { TnAWorkedTimeTotalsDTO } from "../../../../models/tna-worked-time-totals";

interface Props {
  disabled: boolean;
  loadEmployeeGroup: () => Promise<EmployeeGroupDTO | undefined>;
  loadTnAWorkedTimeData: (pageSize?: number) => Promise<LoadResponse<TnAWorkedTimeDTO> | undefined>;
  loadTnAWorkedTimeTotalsData: (pageSize?: number) => Promise<LoadResponse<TnAWorkedTimeTotalsDTO> | undefined>;
  allItems: () => DTOModel[];
  isTotalsView: boolean;
}

const ExportTnAWorkedTimeToExcel = ({
  disabled,
  loadEmployeeGroup,
  loadTnAWorkedTimeData,
  loadTnAWorkedTimeTotalsData,
  allItems,
  isTotalsView,
}: Props) => {
  return (
    <>
      {!isTotalsView && (
        <ExportWorkedTimeTableView
          loadEmployeeGroup={loadEmployeeGroup}
          loadTnAWorkedTimeData={loadTnAWorkedTimeData}
          disabled={disabled}
          allItems={allItems}
        />
      )}

      {isTotalsView && (
        <ExportWorkedTimeTotalsView
          loadEmployeeGroup={loadEmployeeGroup}
          loadTnAWorkedTimeTotalsData={loadTnAWorkedTimeTotalsData}
          disabled={disabled}
          allItems={allItems}
        />
      )}
    </>
  );
};

export default ExportTnAWorkedTimeToExcel;
